__webpack_require__.p = "https://qa-myaccount.dev.dim.atea.com/";